export const menu=[
    {
        id:1,
        name:'home',
        src:'/E-commerce pictures/home.png',
        to: '/'
    },
    {
        id:2,
        name:'phone',
        src:'/E-commerce pictures/mobile-phone.png',
        to: '/phone'
    },
    {
        id:3,
        name:'laptop',
        src:'/E-commerce pictures/notebook-computer.png',
        to: '/laptop'
    },
    {
        id:4,
        name:'shoe',
        src:'/E-commerce pictures/sneakers.png',
        to: '/shoe'
    },
    {
        id:5,
        name:'cloth',
        src:'/E-commerce pictures/tshirt.png',
        to: '/cloth'
    },
    {
        id:7,
        name:'wrist watch',
        src:'/E-commerce pictures/watch.png',
        to: '/unavailable'
    },
    {
        id:8,
        name:'laptop accessories',
        src:'/E-commerce pictures/circuit.png',
        to: '/unavailable'
    },
    {
        id:9,
        name:'electronics',
        src:'/E-commerce pictures/electronics.png',
        to: '/unavailable'
    },
    {
        id:10,
        name:'beauty products',
        src:'/E-commerce pictures/cosmetics.png',
        to: '/unavailable'
    },
    {
        id:11,
        name:'furniture',
        src:'/E-commerce pictures/furnitures.png',
        to: '/unavailable'
    },
    {
        id:12,
        name:'settings',
        src:'/E-commerce pictures/settings.png',
        to: '/unavailable'
    },
    {
        id:13,
        name:'help',
        src:'/E-commerce pictures/information.png',
        to: '/unavailable'
    },
]